/**
 * @generated SignedSource<<d71b8d8b527af5615859a3fd17b7b00d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BUDGET_TYPE = "FIXED_PRICE" | "NON_BILLABLE" | "TIME_AND_MATERIALS" | "RETAINER" | "FIXED_PRICE_V2" | "%future added value";
export type PERIODICITY = "DAILY" | "WEEKLY" | "MONTHLY" | "%future added value";
export type PERIOD_BUDGET_TYPE = "FIXED_PRICE" | "FIXED_HOURS" | "TIME_AND_MATERIALS" | "%future added value";
export type UpdateProjectInput = {
  id?: string | null;
  name?: string | null;
  description?: string | null;
  status?: string | null;
  active?: boolean | null;
  projectColor?: string | null;
  customProjectId?: string | null;
  clientId?: string | null;
  clientContactId?: string | null;
  salespersonId?: string | null;
  projectOwner?: string | null;
  projectManagers?: ReadonlyArray<string | null> | null;
  statusColumns?: ReadonlyArray<StatusColumnInput | null> | null;
  estimationUnit?: string | null;
  sprintTimeBox?: boolean | null;
  sprintLengthInDays?: number | null;
  projectStartYear?: number | null;
  projectStartMonth?: number | null;
  projectStartDay?: number | null;
  projectEndYear?: number | null;
  projectEndMonth?: number | null;
  projectEndDay?: number | null;
  taskLevels?: number | null;
  useTaskHierarchy?: boolean | null;
  rateCardId?: string | null;
  labels?: ReadonlyArray<string | null> | null;
  minutesPerEstimationPoint?: number | null;
  budget?: number | null;
  budgetType?: BUDGET_TYPE | null;
  defaultPeriodPriceAmount?: number | null;
  defaultPeriodHoursAmount?: number | null;
  defaultPeriodBudgetType?: PERIOD_BUDGET_TYPE | null;
  defaultPeriodLength?: number | null;
  defaultPeriodPeriodicity?: PERIODICITY | null;
  defaultPeriodSettingIgnoreForBilling?: boolean | null;
  defaultPeriodSettingSubtractValue?: boolean | null;
  defaultPeriodSettingRollValue?: boolean | null;
  defaultPeriodSettingAddExpenses?: boolean | null;
  revenueMarginLow?: number | null;
  revenueMarginHigh?: number | null;
  economicProjectId?: string | null;
  harvestProjectId?: string | null;
  newHarvestProjectId?: string | null;
  jiraProjectId?: string | null;
  jiraCutoffDate?: string | null;
  excludedHarvestTasks?: ReadonlyArray<string | null> | null;
  newExcludedHarvestTasks?: ReadonlyArray<number | null> | null;
  timelogProjectId?: string | null;
  newTimelogProjectId?: string | null;
  initTaskImport?: boolean | null;
  slackChannelId?: string | null;
  approveNoPhaseTasks?: boolean | null;
  billable?: boolean | null;
  projectGroupId?: string | null;
  previousProjectGroupId?: string | null;
  salesforceOpportunity?: string | null;
  unit4Project?: string | null;
  githubRepositories?: ReadonlyArray<string | null> | null;
  githubRepositoryIds?: ReadonlyArray<number | null> | null;
  remainingAutoCalculated?: boolean | null;
  useManualAllocations?: boolean | null;
  taskCostCalculationType?: string | null;
  unassignedTaskHourlyCost?: number | null;
  useTaskOwner?: boolean | null;
  useTaskFollowers?: boolean | null;
  currencyExchangeRate?: number | null;
  fixedPriceRateCardSetting?: number | null;
  usePublicCreateTaskPage?: boolean | null;
  usePublicCreateTaskPassword?: boolean | null;
  publicCreateTaskPassword?: string | null;
  publicCreateTaskPageStatusColumnId?: string | null;
  unsynchedJiraProject?: boolean | null;
  useBaseline?: boolean | null;
  synchBaselineAndScopingDates?: boolean | null;
  useFixedPriceForBaselineRevenue?: boolean | null;
  useDeliverables?: boolean | null;
  synchDatesSetting?: string | null;
  baselineWinChance?: number | null;
  baselineTarget?: number | null;
  priorityLevelId?: string | null;
  manualProgressOnProjectEnabled?: boolean | null;
  manualProgressOnPhasesEnabled?: boolean | null;
  manualProgressOnTasksEnabled?: boolean | null;
  flatRate?: number | null;
  flatCost?: number | null;
  financialSourceSettings?: FinancialSourceSettingsInput | null;
  sageProjectId?: string | null;
  sageIntacctLocationEntityId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type StatusColumnInput = {
  id?: string | null;
  name?: string | null;
  order?: number | null;
  category?: string | null;
  projectId?: string | null;
  projectGroupStatusColumnId?: number | null;
  autoShowOnTimePage?: boolean | null;
  encourageTimeRegistration?: boolean | null;
};
export type FinancialSourceSettingsInput = {
  plannedHours?: string | null;
  plannedRevenue?: string | null;
  plannedCost?: string | null;
  forecastHours?: string | null;
  forecastRevenue?: string | null;
  forecastCost?: string | null;
  actualHours?: string | null;
  actualRevenue?: string | null;
  actualCost?: string | null;
};
export type UpdateProjectRevenueMarginMutation$variables = {
  input: UpdateProjectInput;
};
export type UpdateProjectRevenueMarginMutation$data = {
  readonly updateProject: {
    readonly project: {
      readonly revenueMarginLow: number | null;
      readonly revenueMarginHigh: number | null;
    } | null;
  } | null;
};
export type UpdateProjectRevenueMarginMutation = {
  variables: UpdateProjectRevenueMarginMutation$variables;
  response: UpdateProjectRevenueMarginMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "revenueMarginLow",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "revenueMarginHigh",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateProjectRevenueMarginMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateProjectPayload",
        "kind": "LinkedField",
        "name": "updateProject",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateProjectRevenueMarginMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateProjectPayload",
        "kind": "LinkedField",
        "name": "updateProject",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0487260f5a0d16f8bacf08636e8ddc83",
    "id": null,
    "metadata": {},
    "name": "UpdateProjectRevenueMarginMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateProjectRevenueMarginMutation(\n  $input: UpdateProjectInput!\n) {\n  updateProject(input: $input) {\n    project {\n      revenueMarginLow\n      revenueMarginHigh\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b42b0ff806b17c5d8054494361d1755c";

export default node;
